import React, { useContext, useEffect, useState } from 'react'
import { useForm, Controller } from 'react-hook-form'
import {
  TextField,
  Grid,
  Divider,
  Button,
  Select,
  MenuItem,
} from '@material-ui/core'
import { ReactComponent as AddSvg } from '../../assets/add.svg'
import {
  InsurancePurchaseContextStore,
  INSURANCE_CONTEXT_ACTIONS,
} from '../../context/InsuracePurchaseContext'
import { PolicyManagementContextStore } from '../../context/PolicyManagementContext'
import FlexView from 'react-flexview/lib'
import NewFillButton from '../Core/NewFillButton'
import {
  EventEmitterService,
  EventKey,
} from '../../services/EventEmitterService'
import { Action } from '../../models/Action'
import { OptionalTag } from '../Core/OptionalTag'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import { BrowserView } from 'react-device-detect'
import policymanagementApi from '../../api/policymanagement.api'
import { awaitWithLoading } from '../../services/utils'
import {
  FirebaseService,
  FirebaseConfigKey,
} from '../../services/FirebaseService'
import { COUNTRIES, STATE_EXPIRY_TTL } from '../../Constants'
import LocalizationService from '../../services/LocalizationService'
import { AdditionalInsuredPureForm } from './AdditionalInsuredPureForm'
// import { PolicyRenewalContextStore } from '../../context/PolicyRenewalContext';
import { SUBSCRIPTION_STATE } from '../../models/insurance-models/PolicySubscriptionState'
import policmanagementRenewalApi from '../../api/policmanagement.renewal.api'
import { UserApi } from '../../api/user.api'

export const AdditionalInsuredForm = (props) => {
  const isPolicyManagementMode = !!props.insurance
  // const renewalContext = useContext(PolicyRenewalContextStore)
  const context = useContext(
    isPolicyManagementMode
      ? PolicyManagementContextStore
      : InsurancePurchaseContextStore
  )
  // const getAdditionalInsuredList = () => isPolicyManagementMode ?
  //     renewalContext.insuranceSubscriptionState == SUBSCRIPTION_STATE.CURRENT ?
  //         props.insurance.additionalInsuredList : props.insurance.subscription.additionalInsuredList
  //      : context.additionalInsuredList
  const getAdditionalInsuredList = () =>
    isPolicyManagementMode
      ? props.insurance.additionalInsuredList
      : context.additionalInsuredList
  const getAllAdditionalInsuredList = () => context.allAdditionalInsuredList

  const onListUpdate = async (activeAiList, allAiList) => {
    if (isPolicyManagementMode) {
      let res = await awaitWithLoading(
        policymanagementApi.addAdditionalInsured(
          props.insurance.insuranceId,
          activeAiList
        )
      )
      if (res.ok) {
        context.dispatch(
          new Action(
            INSURANCE_CONTEXT_ACTIONS.ACTIVE_ADDITIONAL_INSUREDS_UPDATED,
            { insurance: res.parsedData.insurance }
          )
        )
        EventEmitterService.dispatch(EventKey.POLICY_ADDITIONAL_INSURED_CHANGED)
        let resAllAi = await awaitWithLoading(UserApi.getAdditionalInsureds())
        if (resAllAi.ok) {
          context.dispatch(
            new Action(
              INSURANCE_CONTEXT_ACTIONS.TOTAL_ADDITIONAL_INSUREDS_UPDATED,
              { additional_insureds: resAllAi.parsedData }
            )
          )
        }
      } else {
        EventEmitterService.dispatch(EventKey.ShowError, res)
      }
    } else {
      context.dispatch(
        new Action(
          INSURANCE_CONTEXT_ACTIONS.TOTAL_ADDITIONAL_INSUREDS_UPDATED,
          { additional_insureds: allAiList }
        )
      )
      context.dispatch(
        new Action(
          INSURANCE_CONTEXT_ACTIONS.ACTIVE_ADDITIONAL_INSUREDS_UPDATED,
          { additional_insureds: activeAiList }
        )
      )
    }
  }

  const onFinish = () =>
    EventEmitterService.dispatch(EventKey.ADDITIONAL_INSURED_FINISH)

  return (
    <AdditionalInsuredPureForm
      onAdditionalInsuredListUpdate={onListUpdate}
      onFinish={onFinish}
      additionalInsuredList={getAdditionalInsuredList()}
      allAdditionalInsuredList={getAllAdditionalInsuredList()}
    />
  )
}
